var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFutureReceive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17.778,
    viewBox: "0 0 16 17.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_334",
    "data-name": "Uni\\xE3o 334",
    d: "M-1323.223,4105.778A1.781,1.781,0,0,1-1325,4104v-9.778a1.78,1.78,0,0,1,1.777-1.777H-1321a.444.444,0,0,1,.444.444.444.444,0,0,1-.444.444h-2.223a.889.889,0,0,0-.888.889.889.889,0,0,0,.888.889h11.556v-1.779H-1313a.445.445,0,0,1-.445-.444.445.445,0,0,1,.445-.444h1.777a.444.444,0,0,1,.444.444v2.223h1.333a.445.445,0,0,1,.445.444v9.778a.445.445,0,0,1-.445.445Zm-.888-1.778a.888.888,0,0,0,.888.888h13.334v-2.667H-1313a.445.445,0,0,1-.445-.444v-2.667a.446.446,0,0,1,.445-.445h3.111V4096h-13.334a1.76,1.76,0,0,1-.888-.247Zm11.555-2.667h2.667v-1.778h-2.667Zm-4.722-7.209-2.222-1.778a.445.445,0,0,1-.07-.625.445.445,0,0,1,.625-.069l1.5,1.2v-4.409A.444.444,0,0,1-1317,4088a.444.444,0,0,1,.444.444v4.409l1.5-1.2a.444.444,0,0,1,.624.069.445.445,0,0,1-.069.625l-2.223,1.778a.442.442,0,0,1-.277.1A.445.445,0,0,1-1317.278,4094.125Z",
    transform: "translate(1325 -4088)",
    fill: "#142249"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutureReceive);
export default __webpack_public_path__ + "static/media/futureReceive.9042c87e9b76956a812f8ac1b1c16764.svg";
export { ForwardRef as ReactComponent };